import { SubtractiveGenerator } from 'game-logic';
import GameMetrics from '../helpers/game-metrics';
import { BlocksDealer } from './blocks-dealer';

export class LocalDealer implements BlocksDealer {
  private readonly secrets: number[];
  private readonly indexToHash: Map<number, string>;

  constructor(secrets: number[]) {
    this.secrets = secrets;
    this.indexToHash = new Map<number, string>();
  }

  public discloseSecrets(
    indexes: number[],
    gameHash: string,
    _disclosedSecrets: number,
    _existingDeal: boolean,
  ): Promise<number[]> {
    try {
      for (const index of indexes) {
        this.indexToHash.set(index, gameHash);
      }
      return Promise.resolve(indexes.map((index) => this.secrets[index]));
    } catch (error) {
      return Promise.reject([]);
    }
  }

  public static makeRandom(): LocalDealer {
    const seed = Math.floor(new Date().getTime() / 1000);
    const random = new SubtractiveGenerator(seed);

    const secrets: number[] = [];
    for (let i = 0; i < GameMetrics.MaxStage; i++) {
      secrets.push(random.next());
    }
    return new LocalDealer(secrets);
  }
}
